import Vue from "vue";
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list-v2';

Vue.component("classification-treeview", {
	props: ["data", "type", "showCoverageLegend", "classificationSystem", "homePartyId"],
	data() {
		return {
			showCoverageModal: false,
			coverageTitle: null,
			isOpen: null,
			coverageLoading: false,
			coverageModel: {
				hasCoverage: false,				
				coveragePartyName: null,
				partyName: null,
				annexes: [],
				generalNoteAnnexId: null,
				generalNoteCaption: null,
			}
		}
	},
	methods: {
		showPartyCoverage(classification) {			
			const self = this;			

			self.coverageTitle = `Coverage of ${classification.partyName} (${classification.classificationSystemCode} - ${classification.productCode})`;
			self.showCoverageModal = true;

			self.load(classification, false);		
		},
		load(classification, loadSubset) {
			const self = this;

			console.log(classification);

			self.coverageLoading = true;

			if (self.type == "GOODS") {
				self.$services.coverages.getGoodCoverage({
					classificationHierarchyId: classification.classificationHierarchyId,
					classificationSystemId: self.classificationSystem != null ? self.classificationSystem.id : 0,
					partyId: classification.partyId,
					language: window.currentLanguage
				}).then((data) => {
					self.coverageModel.hasCoverage = data.hasCoverage;
					self.coverageModel.annexes = data.annexes;					
					self.coverageModel.generalNoteAnnexId = data.generalNoteAnnexId;
					self.coverageModel.generalNoteCaption = data.generalNoteAnnexDescription;
					self.coverageModel.partyName = classification.partyName;
					self.coverageModel.coveragePartyName = classification.coveragePartyName;

					self.coverageLoading = false;
				});
			}
			else {
				self.$services.coverages.getServiceCoverage({
					classificationHierarchyId: classification.classificationHierarchyId,
					partyId: classification.partyId,
					classificationSystemId: self.classificationSystem != null ? self.classificationSystem.id : 0,
					homePartyId: self.homePartyId,
					language: window.currentLanguage
				}).then((data) => {
					self.coverageModel.hasCoverage = data.hasCoverage;
					self.coverageModel.annexes = data.annexes;
					self.coverageModel.noteAnnexId = data.noteAnnexId;
					self.coverageModel.noteCaption = data.noteAnnexDescription;
					self.coverageModel.generalNoteAnnexId = data.generalNoteAnnexId;
					self.coverageModel.generalNoteCaption = data.generalNoteAnnexDescription;
					self.coverageModel.partyName = classification.partyName;
					self.coverageModel.coveragePartyName = classification.coveragePartyName;

					self.coverageLoading = false;
				});
			}
		},
		openGeneralNote(generalNoteAnnexId) {
			const self = this;

			self.$services.notes.getByAnnexId({
				annexId: generalNoteAnnexId,
				noteType: window.constants.noteType.note,
				language: window.currentLanguage
			}).then((data) => {
				self.coverageModel.generalNotes = data.items;
			});
		},
		discardCoverage() {
			this.showCoverageModal = false;
		},
		openItem(classification) {
			const self = this;			

			self.isOpen = classification.id;
			self.load(classification, true);
		}
	},
	computed: {
		treeData: function () {
			return new Tree(this.data);
		},
		noCoverageLabel: function () {
			return window.labels.noCoverage;
		},
		partialCoverageLabel: function () {
			return window.labels.partialCoverage;
		},
		fullCoverageLabel: function () {
			return window.labels.fullCoverage;
		}
	},
	template: `
		<div>
			<div v-if="showCoverageLegend" class="mb-2">
				<i class="far fa-star primary-text"></i>{{noCoverageLabel}}
				<i class="fas fa-star-half-alt primary-text"></i> {{partialCoverageLabel}}
				<i class="fas fa fa-star primary-text"></i> {{fullCoverageLabel}}
			</div>
			<vue-tree-list
				:model="treeData"
				v-bind:default-expanded="false">
				<template v-slot:leafNameDisplay="props">
					<div class="entity-row" :id="'classification_' + props.model.id" v-if="props.model.children != null && props.model.children.length > 0">					
						<div class="entity-row-display-name" v-html="props.model.name"></div>												
						<a v-if="props.model.coverage != null" class="pl-2" href="#" :title="'Show the coverage of ' + props.model.partyName + ' at this level'" @click.stop.prevent="showPartyCoverage(props.model)">
							<i class="fas fa-eye primary-text"></i>
						</a>
					</div>				
					<b-collapse          
						v-else		         
		                animation="slide"
		                :open="isOpen == props.model.id"
		                @open="openItem(props.model)">
						<template #trigger>
							<div class="entity-row" :id="'classification_' + props.model.id">
								<div class="entity-row-display-name" v-html="props.model.name"></div>
								<a v-if="props.model.coverage != null" class="pl-2" href="#" :title="'Show the coverage of ' + props.model.partyName + ' at this level'" @click.stop.prevent="showPartyCoverage(props.model)">
									<i class="fas fa-eye primary-text"></i>
								</a>
							</div>
						</template>											
	                </b-collapse>												
				</template>
				<template v-slot:treeNodeIcon="props">
					<span class="icon">
						<i v-if="props.model.coverage == 0" class="far fa-star primary-text"></i>
						<i v-else-if="props.model.coverage == 1" class="fas fa-star-half-alt primary-text"></i>
						<i v-else-if="props.model.coverage == 2" class="fas fa fa-star primary-text"></i>
						<i v-else class="fa fa-sitemap"></i>
					</span>
				</template>
			</vue-tree-list>
			<b-modal id="noteCoverageModal" full-screen ref="noteCoverageModal" v-model="showCoverageModal" #default="props" :can-cancel="['x','escape']">
				<div class="modal-card">
					<header class="modal-card-head">
						<p class="modal-card-title">{{coverageTitle}}</p>
						<button type="button" class="delete" @click="discardCoverage" />
					</header>
					<section class="modal-card-body">
						<template v-if="coverageLoading"><loading></loading></template>
						<template v-else>				
							<coverage-viewer :model.sync="coverageModel" type="type" :dynamic="true" :show-reciprocity-message="homePartyId != null"></coverage-viewer>
						</template>
					</section>
				</div>
			</b-modal>
		</div>
	`
});